module.exports = __webpack_public_path__ + "static/CSF2-05e64edbc098b9c7439000a380814ce1.png";